// generated by rustc_codegen_js
